// This file was generated on Tue May 25 18:31:16 CEST 2021
export const appVersion = '1.5.3';
